import Typography from '@mui/material/Typography'
import { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import { colors } from '../../../shared/theme/colors'

const benefits = [
  {
    title: 'Remote first',
    description:
      'Thrive from where you are. Mission Lane is a remote-first company where corporate teams come together regularly for high-impact collaboration.',
  },
  {
    title: 'Health and wealth',
    description:
      'Access full health, dental, and vision benefits, FSA and HSA options, mental health resources, and a 4.5% 401(k) Company Match to help you secure your future.',
  },
  {
    title: 'Wellness and balance',
    description:
      'Count on generous PTO and inclusive parental leave for all new parents. Stay centered with a $100 monthly wellness stipend, a premium Calm app subscription, dedicated mental health resources, and a culture that puts people first.',
  },
]

const OurBenefitsSection: FC = () => (
  <section className="bg-white py-16 lg:py-24">
    <GridContainer>
      <div className="col-span-full md:col-span-6 flex items-start">
        <Typography variant="h2" sx={{ color: colors.Green[900] }} className="md:hidden mb-6">
          Our benefits
        </Typography>
        <Typography variant="h2" className="hidden md:block mx-8 my-6">
          Our benefits
        </Typography>
      </div>
      <div className="col-span-full md:col-span-6 flex flex-col gap-6 md:gap-12">
        {benefits.map(({ title, description }) => (
          <div key={title} className="flex flex-col gap-2 md:gap-3">
            <Typography variant="h4">{title}</Typography>
            <Typography variant="p2" sx={{ color: colors.Ink[600] }}>
              {description}
            </Typography>
          </div>
        ))}
      </div>
    </GridContainer>
  </section>
)

export default OurBenefitsSection
